import LASInterface from '@/appLogic/workbench/LAS/LASInterface'
import XandrInterface from '@/appLogic/workbench/Xandr/XandrInterface'
import {
  SET_ATTRIBUTES,
  SET_FAMILY_ATTRIBUTES,
  SET_INTERFACE,
  SET_SLOTTED_VALUE,
  SET_TARGET,
  SET_ENABLE_DOWN_STREAM,
  SET_ENABLE_SAVE_BUTTON,
  SET_LOADING,
  SET_TARGET_DEFINITION_DIRTY,
  RESET_STORE,
  SET_ENABLE_DEFINITION_ACTIONS,
  CLEAR_ATTRIBUTES,
  SHOW_AUP_MODAL,
  SET_ADVERTISER,
  SET_DATASET_FAMILY,
  STORE_NAME,
  UPDATE_TARGET_NAME,
  SET_AVAILABLE_DESTINATIONS,
  SET_BYOD_TRAITS,
  SET_TARGET_CREATE_ACTION,
} from './actions'
import { WORKBENCH_DEFAULT_STATE } from './index'
import { registerIfNotExist, unregisterIfExists } from '@/store'
import {
  LAS_DESTINATIONS,
  ADDRESSABLE_DESTINATIONS,
  DIGITAL_DESTINATIONS,
  DESTINATIONS,
  ACTIVATION_STATUS,
  TARGET_TYPE,
} from '@/appLogic/targets/Constants'
import { cloneDeep } from 'lodash'

const intersectingDatasets = function (datasetGroups) {
  let intersection = [...datasetGroups[0]]
  for (let i = 1; i < datasetGroups.length; i++) {
    intersection = intersection.filter(d => datasetGroups[i].includes(d))
  }
  return intersection.sort((a, b) => {
    if (a > b) return 1
    else return -1
  })
}

const getFamilyDatasetsFromDataset = function (datasets, datasetFamilies) {
  let datasetGroups = []
  datasets.forEach(dataset => {
    const family = datasetFamilies.datasetToFamily[dataset]
    let familyDatasets = datasetFamilies.familyAssociations[family]
    datasetGroups.push([dataset, ...familyDatasets.relatedDatasets])
  })

  let result = intersectingDatasets(datasetGroups)
  return result
}

const mutations = {
  [SET_TARGET]: (state, target) => {
    state.workbenchTarget = target
  },
  [SET_TARGET_CREATE_ACTION]: (state, action) => {
    state.targetCreateAction = action
  },
  [SET_ATTRIBUTES]: (state, attributes) => {
    state.attributes = attributes
  },
  [SET_DATASET_FAMILY]: (state, families) => {
    state.datasetFamilies = families
  },
  [SET_AVAILABLE_DESTINATIONS]: (state, destinations) => {
    state.availableDestinations = destinations
  },
  /**
   * this will set family attributes and other things like the interface
   * @param {*} state
   * @param {object} payload
   * @param {object} payload.context
   * @param {string} payload.family - the family comes from the file downloaded from S3
   */
  [SET_FAMILY_ATTRIBUTES]: (state, payload) => {
    if (state.interface) {
      let modules = state.interface.getStoreModules()
      for (let mod of modules) {
        unregisterIfExists([STORE_NAME, mod.name])
      }
    }
    state.selectedFamilyDataset = payload.family ? payload.family[0] : payload.family
    const context = payload.context
    console.log(payload)
    if (payload.family) {
      const selectedDatasets = getFamilyDatasetsFromDataset(payload.family, state.datasetFamilies)
      if (!state.availableAttributes) {
        state.availableAttributes = state.attributes
      }
      const newAttributes = []
      for (let attr of state.availableAttributes) {
        // attr.data.id contains the id (dataset name)
        if (selectedDatasets.includes(attr.data.id)) {
          newAttributes.push(attr)
        }
      }
      let dataSetFamilyChanged = !(
        state.selectedDatasets &&
        state.selectedDatasets.length === selectedDatasets.length &&
        state.selectedDatasets.every(function (d) {
          return selectedDatasets.indexOf(d) !== -1
        })
      )
      let isCDPDatasource = [
        'xandr',
        TARGET_TYPE.ADSTRA,
        TARGET_TYPE.PRISM,
        TARGET_TYPE.DNB,
        TARGET_TYPE.MAX,
        TARGET_TYPE.TVE,
        TARGET_TYPE.BYOD,
        TARGET_TYPE.EPSILON,
        TARGET_TYPE.DISCOVERY_PLUS,
        TARGET_TYPE.DCR,
      ].includes(payload.family[0])
      if (dataSetFamilyChanged) {
        state.selectedDatasets = selectedDatasets
        // set the interface here
        if (isCDPDatasource) {
          state.interface = new XandrInterface()
          if (!state.workbenchTarget.xandr_data || state.workbenchTarget.xandr_data === undefined) {
            context.dispatch(SET_TARGET, { ...state.workbenchTarget, xandr_data: { frequency: null } })
          } else if (state.workbenchTarget.activation_status !== ACTIVATION_STATUS.DRAFT) {
            context.dispatch(SET_TARGET, state.workbenchTarget)
          }
        } else {
          state.interface = new LASInterface()
          state.availableDestinations = [...LAS_DESTINATIONS]
        }
      }
      // set Addressable and Digital Destinations
      if (isCDPDatasource) {
        state.availableDestinations = [...ADDRESSABLE_DESTINATIONS, ...DIGITAL_DESTINATIONS]
      }
      // set destinations to digital destinations only if DNB dataset is selected
      payload.family.every(df => {
        if (df === TARGET_TYPE.EPSILON || df === TARGET_TYPE.DCR) {
          state.availableDestinations = [DESTINATIONS.FREEWHEEL]
          return false
        } else if (
          df === TARGET_TYPE.DNB ||
          df === TARGET_TYPE.MAX ||
          df === TARGET_TYPE.TVE ||
          df === TARGET_TYPE.DISCOVERY_PLUS
        ) {
          state.availableDestinations = [...DIGITAL_DESTINATIONS]
          return false
        }

        return true
      })
      // TODO have to destroy any hanging store modules
      let modules = state.interface.getStoreModules()
      for (let mod of modules) {
        registerIfNotExist([STORE_NAME, mod.name], mod.module)
      }
      state.interface.setInterface(context)
    } else {
      state.selectedDatasets = []
    }
  },
  [SET_BYOD_TRAITS]: (state, { traits, target }) => {
    if (traits) {
      if (traits.name === 'BYOD') {
        let byodTraits = { ...traits }
        let newBYODChildren = traits.children.filter(x => {
          if (target.advertiser && target.advertiser.Advertiser_id) {
            return x.advertiserId === target.advertiser.Advertiser_id
          }
        })
        byodTraits.children = newBYODChildren
        state.BYODTraits = byodTraits
      }
    }
  },
  [SET_INTERFACE]: (state, inter) => {
    state.interface = inter
  },
  [SET_SLOTTED_VALUE]: (state, slottedValue) => {
    state.slottedValue = slottedValue
  },
  [SET_ENABLE_DOWN_STREAM]: (state, setValue) => {
    state.enableDownstream = setValue
  },
  [SET_ENABLE_SAVE_BUTTON]: (state, value) => {
    state.enableSaving = value
  },
  [SET_LOADING]: (state, value) => {
    state.loading = value
  },
  [SET_TARGET_DEFINITION_DIRTY]: (state, value) => {
    state.dirty = value
  },
  [RESET_STORE]: state => {
    for (let key of Object.keys(WORKBENCH_DEFAULT_STATE)) {
      state[key] = WORKBENCH_DEFAULT_STATE[key]
    }
  },
  [CLEAR_ATTRIBUTES]: state => {
    state.attributes = null
  },
  [SET_ENABLE_DEFINITION_ACTIONS]: (state, value) => {
    state.enableDefinitionActions = value
  },
  [SHOW_AUP_MODAL]: (state, value) => {
    state.showAUPModal = value
  },
  [SET_ADVERTISER]: (state, advertiser) => {
    state.workbenchTarget.advertiser = advertiser
  },
  [UPDATE_TARGET_NAME]: (state, targetName) => {
    state.workbenchTarget.display_name = targetName
  },
}

export default mutations



// WEBPACK FOOTER //
// ./src/app/appLogic/workbench/common/store/mutations.js